import { render, staticRenderFns } from "./BogoCheckout.vue?vue&type=template&id=b7d00a00&scoped=true&"
import script from "./BogoCheckout.vue?vue&type=script&lang=js&"
export * from "./BogoCheckout.vue?vue&type=script&lang=js&"
import style0 from "./BogoCheckout.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./BogoCheckout.vue?vue&type=style&index=1&id=b7d00a00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7d00a00",
  null
  
)


    import installComponents from "!/Users/leandrosehnembortolotto/Development/Dropsmart/dropsmith-frontend-v2/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BCol, BRow, BContainer} from 'bootstrap-vue'
    installComponents(component, {BCol, BRow, BContainer})
    

export default component.exports